import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { compose } from 'redux';

import Form from 'components/Form';
import { getSubmitStatus } from 'reducers';

const ChangeMDNNewSubForm = ({ newSub, ...props }) => (
  <React.Fragment>
    <Form {...props} submit={'Create New Sub'} />
    {newSub && props.saveStatus === 'SUCCEEDED' ? (
      <Link to={`/att/subscriptions/${newSub.id}/view`}>
        Subscription #{newSub.id}
      </Link>
    ) : null}
  </React.Fragment>
);

const validate = (values) => {
  let errors = {};

  if (!values.mdn) {
    errors.mdn = 'Required';
  }

  return errors;
};

const mapStateToProps = (state) => ({
  saveStatus: getSubmitStatus(state, 'changeMDNSubForm'),
});

const mapDispatchToProps = (dispatch, { sub, createSub }) => {
  return {
    onSubmit: () =>
      dispatch(
        createSub({
          user_profile: sub.user_profile,
          first_name: sub.first_name,
          last_name: sub.last_name,
          agent_id: sub.agent_id,
          preactivation: sub.preactivation,
        }),
      ),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({ form: 'changeMDNSubForm', validate }),
)(ChangeMDNNewSubForm);
